import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import inspectedIcon from "../../assets/professional-reviewing-car-certification-illustration-svg-download-png-14037616.png 2.svg";
import timeIcon from "../../assets/Business deal-bro 1.svg";
import varietyIcon from "../../assets/Vehicle Sale-amico 1.svg";
import priceIcon from "../../assets/Car finance-amico-2 1.svg";
var FleetWhyChoose = function FleetWhyChoose() {
  var _useTranslation = useTranslation(["web_fleet"]),
    tShort = _useTranslation.tShort;
  var items = [{
    icon: inspectedIcon,
    title: "why_inspected_title",
    desc: "why_inspected_desc"
  }, {
    icon: varietyIcon,
    title: "why_variety_title",
    desc: "why_variety_desc"
  }, {
    icon: timeIcon,
    title: "why_time_title",
    desc: "why_time_desc"
  }, {
    icon: priceIcon,
    title: "why_price_title",
    desc: "why_price_desc"
  }];
  return /*#__PURE__*/React.createElement("section", {
    className: "px-4 py-6 md:py-14"
  }, /*#__PURE__*/React.createElement("div", {
    className: "md:max-w-[1200px] md:mx-auto"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-2xl md:text-[30px] font-bold text-primary-new text-center mb-8 md:mb-10"
  }, tShort("why_title", {
    ns: "web_fleet"
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5"
  }, items.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.title,
      className: "flex justify-between items-start gap-4 p-4 md:p-5 rounded-xl bg-white border border-solid border-[#E6E9EF]"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
      className: "text-base md:text-xl font-bold text-primary-new mb-1"
    }, tShort(item.title, {
      ns: "web_fleet"
    })), /*#__PURE__*/React.createElement("p", {
      className: "md:text-sm text-xs text-[#09090B] font-normal leading-relaxed m-0"
    }, tShort(item.desc, {
      ns: "web_fleet"
    }))), /*#__PURE__*/React.createElement("img", {
      src: item.icon,
      alt: tShort(item.title, {
        ns: "web_fleet"
      }),
      loading: "lazy",
      width: 72,
      height: 72,
      className: "w-[72px] h-[72px] flex-shrink-0 object-contain"
    }));
  }))));
};
export default FleetWhyChoose;